import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../../utils";
import { proposedEntityClass, suggestionRefDisplay } from "./suggestionNames";
/**
 * The one place a proposed/declined Team/System name is rendered. Every
 * step-detail surface resolves its ref via `resolveEntityRefDisplay` and routes
 * the `proposed` branch through here, so the colour, and the badge seam below,
 * are added once and show up at all sites at once.
 */ export function ProposedEntityNameLabel({ name, isDeclined, as = "span", className }) {
    const Element = as;
    return /*#__PURE__*/ _jsx(Element, {
        className: cn(proposedEntityClass(isDeclined), className),
        children: name
    });
}
/**
 * Resolve a `suggestion`-typed union ref to its proposed name and render it
 * blue (pending) / red (declined). Anything else renders `fallback`.
 */ export function ProposedEntityName({ entityRef, suggestionInfoById, as, className, fallback = null }) {
    const proposed = suggestionRefDisplay(entityRef, suggestionInfoById);
    if (!proposed) return fallback;
    return /*#__PURE__*/ _jsx(ProposedEntityNameLabel, {
        name: proposed.name,
        isDeclined: proposed.isDeclined,
        as: as,
        className: className
    });
}

//# sourceMappingURL=ProposedEntityName.js.map